import gql from 'graphql-tag';

import { companyFragment } from '~/shared/graphql-queries/companies/index';

export default gql`
  query findManyCompanyQuery(
    $limit: Int = 20
    $filter: FilterFindManyCompanyInput
  ) {
    findManyCompanyQuery(
      filter: $filter
      skip: 0
      limit: $limit
      sort: _ID_ASC
    ) {
      ...CompanyFragment
    }
  }
  ${companyFragment}
`;
